import { ChangeEvent } from 'react';

import { Box } from '@aicon-dev/caas-core';
import { SpinLoading } from 'antd-mobile';
import { Trans, useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { UploadIcon, User } from '~/assets/icons';

interface UploadButtonProps {
  isPhotoOnly?: boolean;
  uploaderId: string;
  width?: string;
  height?: string;
  isLoading: boolean;
  icon?: React.ReactNode;
  title?: string;
  multiple?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const CommentUploadInput = ({
  isPhotoOnly,
  uploaderId,
  width,
  height,
  isLoading,
  onChange,
  icon,
  title,
  multiple,
}: UploadButtonProps) => {
  const { t } = useTranslation('user_info');
  return (
    <>
      {uploaderId === 'profile' ? (
        <>
          <SInput
            id={uploaderId}
            type="file"
            multiple={multiple ? true : false}
            accept={isPhotoOnly ? 'image/*' : undefined}
            onChange={onChange}
            disabled={isLoading}
          />
          <PsLabel htmlFor={uploaderId}>
            {isLoading ? (
              <SpinLoading />
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                <User color="var(--color-primary-400)" />
                <Box as="span" marginLeft="7px" color="var(--color-primary-400)" fontSize="16px">
                  {t('user_info:m_profile_photo_upload')}
                </Box>
              </Box>
            )}
          </PsLabel>
        </>
      ) : (
        <>
          <SInput
            id={uploaderId}
            type="file"
            multiple={multiple ? true : false}
            accept={isPhotoOnly ? 'image/*' : undefined}
            onChange={onChange}
            disabled={isLoading}
          />
          <SLabel
            htmlFor={uploaderId}
            isPhotoOnly={isPhotoOnly}
            width={width}
            height={height}
            icon={icon}
          >
            {isLoading ? (
              <SpinLoading />
            ) : isPhotoOnly ? (
              <>{icon ? icon : <Trans>user_info:m_please_upload_photo</Trans>}</>
            ) : uploaderId === 'comment' ? (
              icon
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                <UploadIcon size="15" />
                <Box as="span" marginLeft="7px" color="var(--black)" fontSize="16px">
                  {title ? title : t('user_info:m_attachments')}
                </Box>
              </Box>
            )}
          </SLabel>
        </>
      )}
    </>
  );
};

export const cssWorkPhotoSize = css`
  width: 72px;
  height: 72px;
`;

const SInput = styled.input`
  display: none;
`;

const SLabel = styled.label<Pick<UploadButtonProps, 'icon' | 'isPhotoOnly' | 'width' | 'height'>>`
  position: 'relative';
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  border: ${({ isPhotoOnly }) => (isPhotoOnly ? undefined : '1px solid var(--adm-border-color)')};
  border-radius: 4px;
  background: ${({ isPhotoOnly, icon }) =>
    isPhotoOnly && icon === undefined ? 'var(--grey-100)' : 'var(--white)'};
  text-align: center;
  ${({ width, height, isPhotoOnly, icon }) => {
    return isPhotoOnly && icon === undefined ? cssWorkPhotoSize : { width, height };
  }}
  cursor: pointer;
`;
const PsLabel = styled.label`
  position: 'relative';
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #40a9ff;
  border-radius: 4px;
  padding: 7px 0;
  width: 100%;

  cursor: pointer;
`;
